import {Observable} from 'rxjs';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {CrisisAlertService} from '../../services/crisis-alert.service';
import {Case} from '../../../_models/case.model';

@Component({
  selector: 'app-case-list',
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.scss'],
})
export class CaseListComponent implements OnInit {
  cases: Observable<Case[]>;
  specialityName: Observable<string>;
  triggerSource: Observable<string>;
  page = 1;
  pageSize = 20;

  constructor(
      private crisisAlertService: CrisisAlertService,
      private router: Router,
  ) {
  }

  ngOnInit() {
    this.crisisAlertService.pageSizeObs.subscribe(x => this.pageSize = x);
    this.crisisAlertService.pageObs.subscribe(x => this.page = x);
    this.cases = this.crisisAlertService.casesObs;
    this.specialityName = this.crisisAlertService.specialityNameObs;
    this.triggerSource = this.crisisAlertService.listTriggerObs;
  }

  gotoCaseDetail(caseId: string) {
    this.router.navigate(['/case', caseId]);
  }

  clearSearchResult() {
    this.crisisAlertService.pushSearchTrigger(true);
    this.crisisAlertService.pushListTrigger('clear');
    this.crisisAlertService.loadAlerts('GNRL');
  }

  pageSizePublish() {
    this.crisisAlertService.pushPageSize(this.pageSize);
  }

  pageNumPublish() {
    this.crisisAlertService.pushPageNum(this.page);
  }
}
